export const ROUTES = {
  ADVERTISEMENT_BLOCK_BASE: "/AdvertisementBlock",
  ADVERTISEMENT_BLOCK_LIST: "/AdvertisementBlock/list",
  ADVERTISEMENT_BLOCK_DETAILS: "/AdvertisementBlock/details",
  ADVERTISEMENT_BLOCK_ADD_MODAL: "/AdvertisementBlock/add",
  ADVERTISEMENT_BOARD_DETAILS: "/advertisement/board/details",
  ADVERTISEMENT_BOARD_TYPES_LIST: "/advertisement/board-types/list",
  ADVERTISEMENT_BLOCK_COMPONENT_TYPES_LIST: "/AdvertisementBlock/component-types/list",
};
